import { useGetDiscountCodeOnMount } from '@user/store/discountCode/hooks/useGetDiscountCodeOnMount'
import { useMemo } from 'react'
import { useDialogState } from '@user/utils/useDialogState'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { ReferralDiscountDetailsDrawer } from '@user/components/DiscountCodes/Details/ReferralDiscountDetailsDrawer/ReferralDiscountDetailsDrawer'
import * as React from 'react'
import { useTheme } from '@mui/material/styles'

interface Props {
  discountCodeId: string
}

export function EntityDetailsDiscountCodeCardSmall(props: Props) {
  const { discountCodeId } = props

  const { discountCode, loadingStatus } =
    useGetDiscountCodeOnMount(discountCodeId)

  const typesCsv = useMemo(
    () =>
      discountCode?.discountLineItems
        .map((x) => `${x.referralType === 0 ? 'New' : 'Existing'} Customer`)
        .filter((value, index, self) => self.indexOf(value) === index)
        .sort()
        .join(', '),
    [discountCode?.discountLineItems],
  )

  const [open, onOpen, onClose] = useDialogState()

  if (loadingStatus === 'pending') {
    return <CircularProgress />
  }

  if (!discountCode) {
    return <Typography>No Discount Code</Typography>
  }
  const theme = useTheme()
  return (
    <Stack spacing={0.8} width={352}>
      <Box>
        <Typography variant="body2" color={theme.palette.text.secondary}>
          Referral Discount (Optional)
        </Typography>
        <Typography variant="subtitle2" color={theme.palette.text.primary}>
          {discountCode.code} - {discountCode.name}
        </Typography>
      </Box>

      <Box>
        <Typography variant="body2" color={theme.palette.text.secondary}>
          Type(s)
        </Typography>
        <Typography variant="subtitle2" color={theme.palette.text.primary}>
          {typesCsv}
        </Typography>

        <ReferralDiscountDetailsDrawer
          onClose={onClose}
          open={open}
          referralDiscountCode={discountCode}
        />
      </Box>

      <Box>
        <Typography variant="body2" color={theme.palette.text.secondary}>
          Details
        </Typography>
        <Typography variant="subtitle2" color={theme.palette.text.primary}>
          {discountCode.description}
        </Typography>
      </Box>

      <Box ml="auto!important" width="fit-content">
        <Button
          variant="outlined"
          color="primary"
          onClick={onOpen}
          size="small"
        >
          <Typography
            fontSize="13px"
            color="#19305A"
            fontFamily="Source Sans Pro Semibold"
          >
            View Full Details
          </Typography>
        </Button>
      </Box>
    </Stack>
  )
}
